/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Replaces the product name in text with the installation name from global config.
   *
   * Procurava por "PowerChat" — nome que a rebrand para PowerbizzOS eliminou do produto
   * inteiro. Ou seja: desde a rebrand este helper não substituía NADA, e as telas que o
   * chamavam (login, webhooks, canais, sugestão de etiqueta) exibiam o texto cru achando que
   * estavam marcando. O docstring já dizia "PowerbizzOS"; só o código é que não tinha sido
   * atualizado junto.
   *
   * Nesta instalação o `INSTALLATION_NAME` também é "PowerbizzOS" (forçado pelo
   * `ensure_brand_name`), então a troca é no-op aqui — o que ela devolve é o white-label
   * funcionando para quem instala com outro nome.
   *
   * @param {string} text - The text to process
   * @returns {string} - Text with the product name replaced by the installation name
   */
  const replaceInstallationName = text => {
    if (!text) return text;

    const installationName = globalConfig.value?.installationName;
    if (!installationName) return text;

    return text.replace(/PowerbizzOS/g, installationName);
  };

  return {
    replaceInstallationName,
  };
}
